import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import SideNav from "./views/sideNavbar";
// import PreAuthorization from "./views/PreAuthorization"
import Login from "./views/LoginViews/login";
import LoginAsAdmin from "./views/Admin/sideAdminNavbar";
import React, { useEffect } from "react";

function App() {
  useEffect(() => {
    document.title = 'Amman Connector';
    return () => {
      document.title = 'Amman Connector';
    };
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Login />} />
          <Route path="/admin" element={<LoginAsAdmin />} />
          {<Route exact path="/kayanPortal" element={<SideNav />} />}{" "}
          {/* <Route path="/preAuthorization" element={<React.Fragment><SideNav screen="auth"/><PreAuthorization /></React.Fragment>} /> */}
          
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
